let loggingOut = false;

export const logoutGuard = {
    activate(): void {
        loggingOut = true;
    },
    isActive(): boolean {
        return loggingOut;
    },
    reset(): void {
        loggingOut = false;
    },
};
